import React from 'react';
export var InbursaLogo = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "data-testid": "inbursa-bank-logo",
    height: "24",
    width: "84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("title", {
    id: "inbursa-logo-title"
  }, title), React.createElement("defs", null, React.createElement("path", {
    d: "M4 0h316a4 4 0 014 4v92a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
    id: "inbursa-a"
  }), React.createElement("mask", {
    fill: "#fff",
    id: "inbursa-b"
  }, React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#inbursa-a"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-126-394h360v1850h-360z",
    fill: "#fff"
  }), React.createElement("g", {
    transform: "translate(-108 -70)"
  }, React.createElement("use", {
    fill: "#f5f7fa",
    xlinkHref: "#inbursa-a"
  }), React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#inbursa-b)"
  }, React.createElement("path", {
    d: "M189 70h-78c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h78c1.7 0 3-1.3 3-3V73c0-1.7-1.4-3-3-3z",
    fill: "#000",
    opacity: ".07"
  }), React.createElement("path", {
    d: "M191 73v18c0 1.1-.9 2-2 2h-78c-1.1 0-2-.9-2-2V73c0-1.1.9-2 2-2h78c1.1 0 2 .9 2 2z",
    fill: "#fff"
  }), React.createElement("g", {
    fill: "#041e41"
  }, React.createElement("path", {
    d: "M127.055 81.992c0-1.68 1.367-3.04 3.053-3.04s3.053 1.36 3.053 3.04-1.367 3.04-3.053 3.04-3.053-1.361-3.053-3.04m-.457.017c0 1.981 1.36 3.305 3.126 3.495h-5.714a7.024 7.024 0 01-.924-3.495zm.01-.428v-5.635a7.01 7.01 0 013.498-.928l.003 3.495c-1.808 0-3.296 1.324-3.5 3.068m3.903-3.075h5.672a6.978 6.978 0 01.943 3.5h-3.51a3.515 3.515 0 00-3.105-3.5m3.1 3.853v5.707a7.01 7.01 0 01-3.506.933l-.002-3.499a3.52 3.52 0 003.51-3.141M138.884 82.803h1.314v-4.277h-1.314zM145.486 78.526v3.206l-2.572-3.206h-2.071v4.277h1.232V79.59l2.57 3.212h2.071v-4.277zM151.514 82.8c1.012 0 1.429-.308 1.429-1.225 0-.757-.353-.866-.923-.949.525-.134.757-.301.757-.994 0-.789-.424-1.103-1.328-1.103h-4.033v4.27zm-2.809-3.335h2.385c.244 0 .378.122.378.36 0 .327-.192.384-.532.384h-2.23zm0 1.59h2.373c.384 0 .557.07.557.366 0 .378-.23.417-.577.417h-2.353zM157.715 80.767c0 .378 0 .628-.141.802-.193.23-.551.204-1.238.204-1.372 0-1.5.04-1.5-1.025v-2.245h-1.315v2.63c0 1.75.91 1.692 3.04 1.692.673 0 1.199-.006 1.565-.129.64-.211.903-.673.903-1.5v-2.693h-1.314zM163.144 81.7c.454 0 .563.166.563.539v.564h1.315v-.77c0-.782-.385-.776-.872-.872.583-.173.924-.25.924-1.282 0-.987-.373-1.353-1.43-1.353h-3.976v4.277h1.315V81.7zm-2.161-2.135h2.052c.563 0 .73.045.73.507 0 .48-.05.596-.66.596-.064 0-.102-.007-.167-.007h-1.955zM170.663 79.837c-.006-.5-.025-.827-.404-1.103-.346-.25-.897-.25-1.878-.25-.917 0-1.546.045-1.815.078-.821.095-1.09.454-1.09 1.3 0 1.412.731 1.257 3.25 1.276.488.007.815 0 .815.385s-.25.392-1.455.392c-.456 0-.776-.014-.885-.02-.455-.038-.397-.262-.404-.455h-1.288c.005.513-.052.866.357 1.16.29.206.931.244 1.93.244 1.021 0 1.7-.045 1.93-.07.783-.09 1.123-.404 1.123-1.295 0-1.263-.642-1.315-2.064-1.315-.174 0-.372.007-.551.007-.302 0-.655-.013-1.033-.02-.27-.005-.436-.115-.436-.326 0-.475.378-.353 1.481-.41.065-.007.102-.007.167-.007.762 0 .955.032.974.43zM176.06 82.803h1.437l-2.334-4.277h-1.757l-2.385 4.277h1.449l.423-.777h2.764zm-2.711-1.66l.923-1.694.91 1.693z"
  }))))));
};
InbursaLogo.defaultProps = {
  title: 'Inbursa'
};